<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M45.8711 85.1184C45.9308 80.1551 46.5727 73.0461 49.2633 64.9854C51.633 57.8876 54.8124 52.3907 57.4321 48.5693"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M14.6602 50.7897C18.4591 48.7297 23.9821 46.3488 30.9382 45.2965C42.8687 43.4903 52.5228 46.5727 57.4375 48.573"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M55.9757 50.4196C58.5072 48.3455 64.2901 44.1837 72.8463 42.7597C80.5861 41.4721 86.824 43.0505 89.9062 44.0587"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M57.4375 48.5691C57.8107 45.0388 59.3183 35.1421 67.2857 26.2232C74.0327 18.6663 81.8806 15.763 85.3811 14.6995"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M57.4375 48.5693C60.1692 50.6144 63.9308 53.9282 67.2745 58.8802C71.6518 65.3623 73.2677 71.628 73.9357 75.3822"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M58.4361 48.2109C55.8052 41.8184 50.4836 31.8993 40.1317 25.1597C39.0047 24.4246 37.8814 23.7678 36.7656 23.1819"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M105.137 63.5987L95.4812 64.3976C94.9733 64.4394 94.5625 64.2621 94.2526 63.8707C93.9383 63.4788 93.8601 63.0429 94.0095 62.5572L94.1984 61.9423C94.2683 61.7197 94.3812 61.5211 94.5456 61.3522C94.71 61.1833 94.901 61.0594 95.1219 60.9903L104.251 58.027"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M111.623 58.589L119.172 68.3405C119.311 68.5203 119.402 68.7255 119.441 68.9511C119.48 69.1767 119.465 69.4 119.397 69.6165L119.213 70.2145C119.067 70.6868 118.763 70.9903 118.295 71.1334C117.826 71.2764 117.401 71.1907 117.017 70.8806L109.673 64.9246L108.065 70.1283L110.709 73.5496C110.82 73.6989 110.889 73.8652 110.925 74.041C110.961 74.2167 110.947 74.3951 110.893 74.5728L110.701 75.1968C110.588 75.5562 110.354 75.8056 110 75.9317C109.642 76.0616 109.305 76.0188 108.986 75.8025L104.728 72.9324L99.5966 72.9005C99.2101 72.8963 98.9058 72.7405 98.6839 72.433C98.4619 72.1256 98.4057 71.7897 98.5189 71.4303L98.7115 70.8019C98.7651 70.6286 98.8562 70.478 98.985 70.3503C99.1138 70.2226 99.2652 70.1293 99.4398 70.066L103.552 68.7342"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M16.4219 106.28C19.083 108.996 23.3242 112.591 29.3358 115.049C41.7111 120.113 57.4298 117.242 70.2755 108.677C94.8968 92.261 90.6484 65.1689 75.059 62.2985C65.4992 60.5389 53.2496 65.1904 54.0145 80.9117C54.5281 91.4475 63.3481 86.796 59.1823 73.68C56.6074 65.5739 49.662 61.1947 40.447 62.3737C19.5247 65.0507 16.1058 103.933 59.4911 114.078C66.8315 115.794 76.1974 114.651 84.7839 110.269C90.458 107.373 95.2307 102.209 98.3084 96.6401C99.4037 94.662 99.9639 93.5869 100.406 92.562C100.567 92.1893 101.167 90.7845 101.785 88.8135C102.902 85.2371 103.458 81.7323 103.745 79.2417"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.918 67.2794C108.53 53.14 109.86 48.4461 111.83 48.4646C113.911 48.4836 112.433 54.7206 108.568 67.9806"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M21.8134 75.9456C21.4887 77.6659 21.1901 80.2856 21.5521 83.4688C22.1268 88.5366 24.0524 92.2086 25.0973 93.9402"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M22.4734 29.4393C22.4734 29.4393 23.4846 25.2008 24.2502 25.7648C25.0157 26.3289 26.8771 30.6843 25.7933 31.4296C24.7054 32.175 22.425 28.7141 27.5862 29.3063C31.168 29.7173 30.4307 30.3257 29.2824 31.2161C28.1341 32.1065 21.4943 38.138 20.7368 37.0098C19.9794 35.8817 22.5177 33.5408 21.1921 32.4812C19.8666 31.4216 17.7715 30.6964 18.4 29.8422C18.9278 29.125 20.6603 29.3104 20.6603 29.3104"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M27.0364 33.1096C27.0364 33.1096 28.4667 36.4457 27.6448 36.9694C27.2459 37.2233 26.013 36.4618 25.457 36.079"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.797 23.5105L103.804 25.6749"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.816 29.6902L103.824 31.8546"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M99.6367 27.6972L101.801 27.6897"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M105.816 27.6752L107.981 27.6677"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
